export default "__VITE_ASSET__IjlN6ZgO__"